export default [
  {
    path: '/admin/trader/script-signal',
    name: 'ScriptSignal',
    component: () => import('@/views/Admin/Trader/ScriptSignal/Index.vue'),
    meta: {
      pageTitle: 'Script Signal',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Script Signal', active: true },
      ],
      resource: 'edges.manage',
      action: 'read',
    },
  },
]
